import { Navigate } from 'react-router-dom';
import React, { useState } from 'react';

import NumberedItem from '../../components/layouts/NumberedItem';
import Image from '../../components/frames/Image';
import Video from '../../components/frames/Video';
import Ripple from '../../components/floaters/Ripple';
import ButtonBox from './../../components/buttons/ButtonBox';
import ButtonText from '../../components/buttons/ButtonText';

import classes from './IndividualWorks.module.css';
import { scrollIntoPosition } from '../../components/helpers/helpers';

import brandImg from './../../assets/img/logos/logo-paladise.png';
import videoWebm from './../../assets/vid/responsive/responsive-paladise.webm';

const PaladisePage = (props, ref) => {
  // Navigation
  const [toGoBackPage, setGoBackPage] = useState(false);

  if (toGoBackPage === true) return <Navigate to="/works" />;

  const navigateHandler = () => {
    setGoBackPage(true);
    scrollIntoPosition('top');
  };

  const clickCtaHandler = () => {
    window.location.href = 'https://paladise.netlify.app';
  };

  const clickGhostHandler = () => {
    window.location.href = 'https://github.com/kershey28';
  };

  return (
    <div className={`${classes.container} ${props.class}`}>
      <Ripple />
      <NumberedItem
        number="7"
        title="Your Paradise Tour"
        class={classes.heading}
        ref={ref}
      />

      <Image img={brandImg} class={classes.brandImg} />

      <Video webm={videoWebm} class={classes.video} />

      <div className={classes.contentBox}>
        <h2 className={`${classes.contentHeading} heading-2`}>
          Showcasing the island of Palawan.
        </h2>
        <h3
          className={`${classes.contentParagraph} ${classes.contentParagraph1} heading-3`}
        >
          A
          <span className={`${classes.highlightText} heading-2`}>
            {' '}
            vanilla{' '}
          </span>
          JavaScript website that promotes tour in
          <span className={`${classes.highlightText} heading-2`}>
            {' '}
            Palawan{' '}
          </span>
          in the Philippines. This is built with HTML and
          <span className={`${classes.highlightText} heading-2`}> SCSS</span>.
        </h3>

        <h3
          className={`${classes.contentParagraph} ${classes.contentParagraph2} heading-3`}
        >
          This is the
          <span className={`${classes.highlightText} heading-2`}> first </span>
          website that I built and also the
          <span className={`${classes.highlightText} heading-2`}>
            {' '}
            longest{' '}
          </span>
          time that I took on building a website --- 3 weeks. Back then, I
          struggled on managing file structure to keep my codes
          <span className={`${classes.highlightText} heading-2`}> uniform</span>
          . Especially, making my layout to be responsive in all screen sizes.
        </h3>

        <h3
          className={`${classes.contentParagraph} ${classes.contentParagraph3} heading-3`}
        >
          But all the difficulties that I've encountered are all
          <span className={`${classes.highlightText} heading-2`}> worth </span>
          it. Now, I'm thankful that responsiveness is one of my forte; also, I
          can build
          <span className={`${classes.highlightText} heading-2`}> more </span>
          complex website in just days.
        </h3>

        <ButtonText
          text="Check other brands"
          onClick={navigateHandler}
          class={classes.buttonBack}
        />

        <ButtonBox
          cta="Discover live"
          ghost="Go to repository"
          class={classes.button}
          onClickCta={clickCtaHandler}
          onClickGhost={clickGhostHandler}
        />
      </div>
    </div>
  );
};

export default React.forwardRef(PaladisePage);
